var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a = require('./tokens'), turtleTokenTypes = _a.turtleTokenTypes, turtleTokenMap = _a.turtleTokenMap;
import { Parser, Lexer, } from 'chevrotain';
var TurtleParser = /** @class */ (function (_super) {
    __extends(TurtleParser, _super);
    function TurtleParser(config, tokens, lexerDefinition, performSelfAnalysis) {
        if (config === void 0) { config = {}; }
        if (tokens === void 0) { tokens = turtleTokenTypes; }
        if (lexerDefinition === void 0) { lexerDefinition = tokens; }
        if (performSelfAnalysis === void 0) { performSelfAnalysis = true; }
        var _this = _super.call(this, tokens, __assign({ outputCst: true, recoveryEnabled: true }, config)) || this;
        // Parsing Turtle requires that the parser keep a map of namespaces in state.
        // Empty prefixes, for example, are allowed only if the empty prefix has been
        // added to the namespaces map (for now, that's all this tracks). (TODO: We
        // might want to use a visitor for this, but I'm doing it quick-and-dirty for
        // now.)
        // See here: https://www.w3.org/TR/turtle/#handle-PNAME_LN
        _this.namespacesMap = {};
        _this.semanticErrors = [];
        // Clears the state that we have to manage on our own for each parse (see
        // above for details).
        _this.resetManagedState = function () {
            _this.namespacesMap = {};
            _this.semanticErrors = [];
        };
        _this.tokenize = function (document) {
            return _this.lexer.tokenize(document).tokens;
        };
        // NOTE: This parser can parse in two modes, 'standard' and 'stardog'. The
        // latter includes non-standard features like embedded triples patterns (edge
        // properties).
        _this.parse = function (document, mode) {
            if (mode === void 0) { mode = 'standard'; }
            _this.input = _this.lexer.tokenize(document).tokens;
            var cst = _this.turtleDoc(0, [mode]);
            // Next two items are copied so that they can be returned/held after parse
            // state is cleared.
            var errors = _this.errors.slice();
            var semanticErrors = _this.semanticErrors.slice();
            _this.resetManagedState();
            return {
                errors: errors,
                semanticErrors: semanticErrors,
                cst: cst,
            };
        };
        _this.turtleDoc = _this.RULE('turtleDoc', function (mode) {
            var allowEdgeProperties = mode === 'stardog';
            _this.MANY(function () {
                return _this.SUBRULE(_this.statement, { ARGS: [allowEdgeProperties] });
            });
        });
        _this.statement = _this.RULE('statement', function (allowEdgeProperties) {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.directive); } },
                {
                    ALT: function () {
                        _this.SUBRULE(_this.triples, { ARGS: [allowEdgeProperties] });
                        _this.CONSUME(turtleTokenMap.Period);
                    },
                },
            ]);
        });
        _this.directive = _this.RULE('directive', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.prefixID); } },
                { ALT: function () { return _this.SUBRULE(_this.base); } },
                { ALT: function () { return _this.SUBRULE(_this.sparqlPrefix); } },
                { ALT: function () { return _this.SUBRULE(_this.sparqlBase); } },
            ]);
        });
        _this.prefixID = _this.RULE('prefixID', function () {
            _this.CONSUME(turtleTokenMap.TTL_PREFIX);
            var pnameNsToken = _this.CONSUME(turtleTokenMap.PNAME_NS);
            var iriToken = _this.CONSUME(turtleTokenMap.IRIREF);
            var pnameImageWithoutColon = pnameNsToken.image.slice(0, -1);
            var iriImage = iriToken.image;
            _this.namespacesMap[pnameImageWithoutColon] = iriImage;
            _this.CONSUME(turtleTokenMap.Period);
        });
        _this.base = _this.RULE('base', function () {
            _this.CONSUME(turtleTokenMap.TTL_BASE);
            _this.CONSUME(turtleTokenMap.IRIREF);
            _this.CONSUME(turtleTokenMap.Period);
        });
        _this.sparqlBase = _this.RULE('sparqlBase', function () {
            _this.CONSUME(turtleTokenMap.BASE);
            _this.CONSUME(turtleTokenMap.IRIREF);
        });
        _this.sparqlPrefix = _this.RULE('sparqlPrefix', function () {
            _this.CONSUME(turtleTokenMap.PREFIX);
            var pnameNsToken = _this.CONSUME(turtleTokenMap.PNAME_NS);
            var iriToken = _this.CONSUME(turtleTokenMap.IRIREF);
            var pnameImageWithoutColon = pnameNsToken.image.slice(0, -1);
            var iriImage = iriToken.image;
            _this.namespacesMap[pnameImageWithoutColon] = iriImage;
        });
        // NOTE: Not part of Turtle spec. Part of Stardog's support for edge
        // properties/embedded triples/a subset of RDF*.
        // ALSO NOTE: Intentionally does not conform to the RDF* spec.
        // Stardog does not allow nesting of embedded triples.
        _this.triples = _this.RULE('triples', function (allowEdgeProperties) {
            _this.OR([
                {
                    ALT: function () {
                        _this.SUBRULE(_this.subject);
                        _this.SUBRULE1(_this.predicateObjectList, {
                            ARGS: [allowEdgeProperties],
                        });
                    },
                },
                {
                    GATE: function () { return Boolean(allowEdgeProperties); },
                    ALT: function () {
                        _this.SUBRULE(_this.EmbeddedTriplePattern);
                        _this.SUBRULE(_this.predicateObjectList);
                    },
                },
                {
                    ALT: function () {
                        _this.SUBRULE(_this.blankNodePropertyList, {
                            ARGS: [allowEdgeProperties],
                        });
                        _this.OPTION(function () {
                            return _this.SUBRULE2(_this.predicateObjectList, {
                                ARGS: [allowEdgeProperties],
                            });
                        });
                    },
                },
            ]);
        });
        // NOTE: Not part of Turtle spec. Part of Stardog's support for edge
        // properties/embedded triples/a subset of RDF*.
        // ALSO NOTE: Intentionally does not conform to the RDF* spec.
        // Stardog does not allow nesting of embedded triples.
        _this.EmbeddedTriplePattern = _this.RULE('EmbeddedTriplePattern', function () {
            _this.CONSUME(turtleTokenMap.LEmbed);
            _this.SUBRULE(_this.triples);
            _this.CONSUME(turtleTokenMap.REmbed);
        });
        // NOTE: Not part of Turtle spec. Part of Stardog's support for edge
        // properties/embedded triples/a subset of RDF*.
        // ALSO NOTE: Intentionally does not conform to the RDF* spec.
        // Stardog does not allow embedded triples with object lists.
        _this.predicateObjectList = _this.RULE('predicateObjectList', function (allowEdgeProperties) {
            _this.SUBRULE(_this.verb);
            _this.OR([
                {
                    ALT: function () {
                        return _this.SUBRULE(_this.objectList, { ARGS: [allowEdgeProperties] });
                    },
                },
                {
                    GATE: function () { return Boolean(allowEdgeProperties); },
                    ALT: function () {
                        _this.SUBRULE(_this.EmbeddedPredicateObjectList);
                        _this.SUBRULE(_this.object, { ARGS: [allowEdgeProperties] });
                    },
                },
            ]);
            _this.MANY(function () {
                _this.CONSUME(turtleTokenMap.Semicolon);
                _this.OPTION(function () {
                    _this.SUBRULE1(_this.verb);
                    _this.OR1([
                        {
                            ALT: function () {
                                return _this.SUBRULE1(_this.objectList, { ARGS: [allowEdgeProperties] });
                            },
                        },
                        {
                            GATE: function () { return Boolean(allowEdgeProperties); },
                            ALT: function () {
                                _this.SUBRULE1(_this.EmbeddedPredicateObjectList);
                                _this.SUBRULE1(_this.object, { ARGS: [allowEdgeProperties] });
                            },
                        },
                    ]);
                });
            });
        });
        // NOTE: Not part of Turtle spec. Part of Stardog's support for edge
        // properties/embedded triples/a subset of RDF*.
        // ALSO NOTE: Intentionally does not conform to the RDF* spec.
        // Stardog does not allow nesting of embedded triples.
        _this.EmbeddedPredicateObjectList = _this.RULE('EmbeddedPredicateObjectList', function () {
            _this.CONSUME(turtleTokenMap.LCurly);
            _this.SUBRULE(_this.predicateObjectList);
            _this.CONSUME(turtleTokenMap.RCurly);
        });
        _this.subject = _this.RULE('subject', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.iri); } },
                { ALT: function () { return _this.SUBRULE(_this.BlankNode); } },
                { ALT: function () { return _this.SUBRULE(_this.collection); } },
            ]);
        });
        _this.predicate = _this.RULE('predicate', function () {
            _this.SUBRULE(_this.iri);
        });
        _this.objectList = _this.RULE('objectList', function (allowEdgeProperties) {
            _this.SUBRULE(_this.object, { ARGS: [allowEdgeProperties] });
            _this.MANY(function () {
                _this.CONSUME(turtleTokenMap.Comma);
                _this.SUBRULE1(_this.object, { ARGS: [allowEdgeProperties] });
            });
        });
        _this.verb = _this.RULE('verb', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.predicate); } },
                { ALT: function () { return _this.CONSUME(turtleTokenMap.A); } },
            ]);
        });
        _this.literal = _this.RULE('literal', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.RDFLiteral); } },
                { ALT: function () { return _this.SUBRULE(_this.NumericLiteral); } },
                { ALT: function () { return _this.SUBRULE(_this.BooleanLiteral); } },
            ]);
        });
        _this.blankNodePropertyList = _this.RULE('blankNodePropertyList', function (allowEdgeProperties) {
            _this.CONSUME(turtleTokenMap.LBracket);
            _this.SUBRULE(_this.predicateObjectList, { ARGS: [allowEdgeProperties] });
            _this.CONSUME(turtleTokenMap.RBracket);
        });
        _this.object = _this.RULE('object', function (allowEdgeProperties) {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.iri); } },
                { ALT: function () { return _this.SUBRULE(_this.BlankNode); } },
                { ALT: function () { return _this.SUBRULE(_this.collection); } },
                {
                    ALT: function () {
                        return _this.SUBRULE(_this.blankNodePropertyList, {
                            ARGS: [allowEdgeProperties],
                        });
                    },
                },
                { ALT: function () { return _this.SUBRULE(_this.literal); } },
            ]);
        });
        _this.collection = _this.RULE('collection', function () {
            _this.CONSUME(turtleTokenMap.LParen);
            _this.MANY(function () { return _this.SUBRULE(_this.object); });
            _this.CONSUME(turtleTokenMap.RParen);
        });
        _this.NumericLiteral = _this.RULE('NumericLiteral', function () {
            _this.OR([
                { ALT: function () { return _this.CONSUME(turtleTokenMap.INTEGER); } },
                { ALT: function () { return _this.CONSUME(turtleTokenMap.DECIMAL); } },
                { ALT: function () { return _this.CONSUME(turtleTokenMap.DOUBLE); } },
            ]);
        });
        _this.RDFLiteral = _this.RULE('RDFLiteral', function () {
            _this.SUBRULE(_this.String);
            _this.OPTION(function () {
                _this.OR([
                    { ALT: function () { return _this.CONSUME(turtleTokenMap.LANGTAG); } },
                    {
                        ALT: function () {
                            _this.CONSUME(turtleTokenMap.DoubleCaret);
                            _this.SUBRULE(_this.iri);
                        },
                    },
                ]);
            });
        });
        _this.BooleanLiteral = _this.RULE('BooleanLiteral', function () {
            _this.OR([
                { ALT: function () { return _this.CONSUME(turtleTokenMap.TRUE); } },
                { ALT: function () { return _this.CONSUME(turtleTokenMap.FALSE); } },
            ]);
        });
        _this.String = _this.RULE('String', function () {
            _this.OR([
                { ALT: function () { return _this.CONSUME(turtleTokenMap.STRING_LITERAL_QUOTE); } },
                { ALT: function () { return _this.CONSUME(turtleTokenMap.STRING_LITERAL_SINGLE_QUOTE); } },
                {
                    ALT: function () {
                        return _this.CONSUME(turtleTokenMap.STRING_LITERAL_LONG_SINGLE_QUOTE);
                    },
                },
                { ALT: function () { return _this.CONSUME(turtleTokenMap.STRING_LITERAL_LONG_QUOTE); } },
            ]);
        });
        _this.iri = _this.RULE('iri', function () {
            _this.OR([
                { ALT: function () { return _this.CONSUME(turtleTokenMap.IRIREF); } },
                { ALT: function () { return _this.SUBRULE(_this.PrefixedName); } },
            ]);
        });
        _this.PrefixedName = _this.RULE('PrefixedName', function () {
            var prefixedNameToken = _this.OR([
                { ALT: function () { return _this.CONSUME(turtleTokenMap.PNAME_LN); } },
                { ALT: function () { return _this.CONSUME(turtleTokenMap.PNAME_NS); } },
            ]);
            var pnameNsImage = prefixedNameToken.image.slice(0, prefixedNameToken.image.indexOf(':'));
            if (!(pnameNsImage in _this.namespacesMap)) {
                _this.semanticErrors.push({
                    name: 'NoNamespacePrefixError',
                    message: 'A prefix was used for which there was no namespace defined.',
                    token: prefixedNameToken,
                    context: {
                        ruleStack: _this.getHumanReadableRuleStack(),
                        ruleOccurrenceStack: _this.RULE_OCCURRENCE_STACK.slice(),
                    },
                    resyncedTokens: [],
                });
            }
        });
        _this.BlankNode = _this.RULE('BlankNode', function () {
            _this.OR([
                { ALT: function () { return _this.CONSUME(turtleTokenMap.BLANK_NODE_LABEL); } },
                { ALT: function () { return _this.CONSUME(turtleTokenMap.ANON); } },
            ]);
        });
        _this.lexer = new Lexer(lexerDefinition);
        if (performSelfAnalysis) {
            Parser.performSelfAnalysis(_this);
        }
        return _this;
    }
    return TurtleParser;
}(Parser));
export { TurtleParser };
